import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import "./DistrictMorePage.css";


export default function DistrictMorePage() {

  const navigate = useNavigate();
  const { t1, t2 } = useParams();

  const [districts, setDistricts] = useState([]);

 useEffect(() => {

  const district = localStorage.getItem("selectedDistrict");
  const stateId = localStorage.getItem("selectedStateId");

  if (!district || !stateId) return;

  fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/other-district-industries-next?excludeDistrict=${district}&state_id=${stateId}`
  )
    .then(res => res.json())
    .then(data => setDistricts(data))
    .catch(err => console.error(err));

}, []);


 return (
  <div className="district-page">

   <div className="district-header">
    <button
        className="district-back-btn"
        onClick={() => navigate(`/mind-mapping/sec-b/${t1}/${t2}`)}
    >
        <FaArrowLeft />
    </button>

    <h1 className="district-title">
        Districts
    </h1>
</div>


    {districts.length === 0 && (
      <p className="district-empty">
        No additional districts available.
      </p>
    )}

    {/* LIST */}
   <ul className="district-list">
  {districts.map((item,i)=>(
    <li key={i} className="district-item">
        <b>{item.district_name}</b> — 
        Unit: {item.unit_name}, 
        Activity: {item.line_of_activity}
    </li>
  ))}
</ul>


  </div>
);

}
